/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, bohdev
 */
import React, { Component } from "react"
import { Loading, ModalTitle, Route, TitleSection } from "trux"
import { connect, useDispatch } from "react-redux"
import { ModalPage } from "../Navigation"
import { pageTitle, Row } from "trux"
import {
    Button,
    Modal,
    ContentSection,
    LoginForm,
    tryLogin,
    trackEvent,
    clearToken,
} from "trux"
import * as act from "./actions"
import * as stat from "../../util/analytics"
import * as localForage from "localforage"
import * as qs from "query-string"

import traceBotImage from "../../assets/img/login-tracebot.svg"
import logoImage from "../../assets/img/topbar-logo.svg"
import loadingImage from "../../assets/img/login-loading.svg"

import "./session.css"

export default class Session extends Component {
    render() {
        console.log("Session.render")
        return (
            <>
                <Route
                    path="/session/mischief/managed"
                    component={MagicLoginPage}
                />
                <Route
                    path="/:team/session/waiting"
                    render={() => (
                        <Row
                            justifyContent="center"
                            alignItems="center"
                            height="100vh"
                        >
                            <Loading />
                        </Row>
                    )}
                />
                <Route
                    path="/:team/session/login"
                    exact
                    component={LoginPage}
                />
                <Route
                    path="/:team/session/login/userid"
                    component={TryLogin}
                />
            </>
        )
    }
}

function TryLogin(props) {
    let dispatch = useDispatch()

    //find guest* path part in the url
    let context = "Session Login"
    let app = document.querySelector("div.App")

    trackEvent({
        context: context,
        action: "Sign-In Email Link Pressed",
        element: app,
    })

    //immediately redirect to the other route so
    //that TryLogin called only once while we are completing the log-in procedure
    props.history.replace(`/${props.match.params.team}/session/waiting`)

    //in case we didn't get the login result in 15 sec, we redirect to login flow again
    const timerId = setTimeout(() => {
        dispatch({ type: "COMMON_RESET" })
        props.history.replace("/tbd/session/login")
    }, 15000)

    tryLogin(props.location.pathname, (res, err) => {
        clearTimeout(timerId)
        let path = `/${props.match.params.team}`
        if (
            props.match.params.team === "" ||
            props.match.params.team === "expelliarmus" ||
            props.match.params.team === "tbd" ||
            props.match.params.team === "magic"
        ) {
            const queryParams = qs.parse(props.location.search)
            path = queryParams?.redirect ? queryParams.redirect : "/"
        }
        console.log("res", res, "err", err, "path", path)
        setTimeout(() => {
            dispatch({ type: "COMMON_RESET" })
            props.history.replace(path)
        }, 1500)
    })

    return null
}

class MagicLogin extends Component {
    constructor(props) {
        super(props)
        this.timeout = null

        this.state = { log: "", count: 0 }
    }

    componentDidMount() {
        this.props.reset()
        stat.statPageView()
        this.runCheck()
        pageTitle("Magic Login", "Session - Magic Login")
    }

    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    runCheck() {
        //this.props.init("expelliarmus")

        if (this.state.count > 4) {
            window.location.href = window.location.href.replace(
                "/session/mischief/managed",
                "/expelliarmus/session/login"
            )
            alert("Magic Login Failed", "Please try to log in again.")
            return
        }

        this.setState({ count: this.state.count + 1 })
        var that = this
        this.timeout = setTimeout(() => {
            console.log("runCheck timeout running")
            that.runCheck()
        }, 1500)
    }

    checkForLogin(props) {
        // var log = this.state.log
        // log += "\nRON LOOK HERE\n"
        // log += `isLoggedIn ${props.isUserLoggedIn}\n`
        // log += `divisions ${props.divisions.length}\n`
        // log += `divisionsDidLoad ${props.divisionsDidLoad}\n`
        // log += "---\n"
        //
        // console.log(log)
        // this.setState({ log })

        if (props.isUserLoggedIn && props.divisionsDidLoad) {
            const queryParams = qs.parse(this.props.location.search)
            const redirect = queryParams ? queryParams.redirect : null

            if (redirect) {
                if (redirect.startsWith("http")) {
                    window.open(redirect)
                    props.history.replace("")
                } else {
                    props.history.replace(redirect)
                }
            } else {
                localForage.getItem("current_team_id").then((lastTeamId) => {
                    if (
                        lastTeamId &&
                        lastTeamId !== "tbd" &&
                        lastTeamId !== "expelliarmus"
                    ) {
                        console.log("lastTeamId:", lastTeamId)
                        props.history.replace("/" + lastTeamId)
                    } else {
                        var mostGamesPlayed = -1
                        var fteam = "no-team"
                        for (var i in props.divisions) {
                            var div = props.divisions[i]
                            for (var t in div.myTeams) {
                                var team = div.myTeams[t]
                                if (team.games_played > mostGamesPlayed) {
                                    mostGamesPlayed = team.games_played
                                    fteam = team.name
                                }
                            }
                        }
                        console.log("mostGamesPlayed", mostGamesPlayed)
                        clearTimeout(this.timeout)
                        props.history.replace("/" + fteam)
                    }
                })
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.checkForLogin(nextProps)
    }

    render() {
        return (
            <div className="MagicLogin">
                <img alt="trace" className="logo" src={logoImage} />
                <p>One moment please while we log you in &hellip;</p>
                <img alt="loading" className="loading" src={loadingImage} />
                <img
                    alt="trace-bot"
                    className="trace-bot"
                    src={traceBotImage}
                />
            </div>
        )
    }
}

class LoginPageComponent extends Component {
    constructor(props) {
        super(props)

        this.state = {
            email: "",
            password: "",
            showPassword: false,
            showSent: false,
            magicError: null,
            passwordError: null,
            loading: null,
        }

        this.onClose = this.onClose.bind(this)
        this.onEmailChanged = this.onEmailChanged.bind(this)
        this.handleMagicLink = this.handleMagicLink.bind(this)
        this.handleLogin = this.handleLogin.bind(this)
        this.loginSuccess = this.loginSuccess.bind(this)
        this.loginFailure = this.loginFailure.bind(this)
        this.handleContinueAsGuest = this.handleContinueAsGuest.bind(this)
    }

    componentDidMount() {
        stat.statPageView()
        pageTitle("Login", "Session Login")
        // Determine if these is a redirect link
    }

    onClose() {
        stat.statEvent("session", "close", "pressed")
        if (window.history && this.props.match.params.team === "expelliarmus") {
            const queryParams = qs.parse(this.props.location.search)
            const redirect = queryParams ? queryParams.redirect : null
            if (redirect) {
                this.props.history.replace(redirect)
            }
            window.history.go(-1)
        } else {
            this.props.history.push("/")
        }
    }

    onEmailChanged(email) {
        let passwordError = null
        let magicError = null
        this.setState({ magicError, email, passwordError })
    }

    handleMagicLink(e) {
        console.log("handleMagicLink")
        stat.statEvent("session", "get-magic-link", "pressed")
        if (e) {
            e.preventDefault()
        }
        var that = this
        this.props.sendMagicLink(this.state.email, null, (success, err) => {
            console.log("handleMagicLink", success, err)
            if (success) {
                that.setState({
                    showPassword: false,
                    showSent: true,
                    magicError: null,
                })
            } else {
                that.setState({
                    magicError:
                        "We couldn’t find this email in our system. Please check it or contact your team manager to add you to the roster.",
                })
            }
        })
    }

    handleLogin(e) {
        stat.statEvent("session", "login-email", "pressed")
        this.setState({ loading: true })

        console.log("handleLogin")
        if (e) {
            e.preventDefault()
        }
        this.props.login(this.state.email, this.state.password, (json, err) => {
            // eslint-disable-next-line eqeqeq
            if (err == null) {
                this.props.reset()
                console.log("common reset")
                setTimeout(() => {
                    if (this.props.teamId === "expelliarmus") {
                        this.props.history.push("/session/mischief/managed")
                    } else {
                        this.props.history.push(`/${this.props.teamId}`)
                    }
                }, 500)
            } else {
                this.setState({
                    passwordError: "Invalid email or password",
                    loading: false,
                })
            }
        })
    }

    loginSuccess(redirect) {
        this.setState({ loading: true })
        this.props.reset()
        console.log("common reset")
        setTimeout(() => {
            this.setState({ loading: false })
            let newURL = "/session/mischief/managed"
            if (redirect) newURL = newURL + "?redirect=" + redirect
            if (
                this.props.teamId === "expelliarmus" ||
                this.props.teamId.length !== 8
            ) {
                this.props.history.push(newURL)
            } else {
                this.props.history.push(`/${this.props.teamId}`)
            }
        }, 1500)
    }

    loginFailure() {}

    handleContinueAsGuest(e) {
        trackEvent({ action: "Continue as Guest", element: e.currentTarget })
        const queryParams = qs.parse(this.props.location.search)
        const redirect = queryParams ? queryParams.redirect : null
        const baseUrl = window.location.origin + window.location.pathname + "#"
        let newUrl = baseUrl
        if (redirect) {
            newUrl = `${baseUrl}${redirect}`
        }
        window.location.href = newUrl
    }

    render() {
        const queryParams = qs.parse(this.props.location.search)
        const redirect = queryParams ? queryParams.redirect : null
        let title = (
            <img
                alt="Trace Login"
                style={{ position: "relative", top: 6 }}
                src={logoImage}
            />
        )
        return (
            <ModalPage
                trkContext={
                    this.props.trkContext
                        ? this.props.trkContext
                        : "Session Login"
                }
                title={title}
                showBack
                showClose
            >
                <Modal trkContext={"Magic Session Login"} open={true}>
                    <TitleSection
                        onCloseClick={() => this.props.history.goBack()}
                    >
                        <ModalTitle content="Sign in to Trace" />
                    </TitleSection>
                    <ContentSection>
                        <Row center spacingBottom="4" span="12">
                            <LoginForm
                                center
                                redirectURL={redirect}
                                onSuccess={this.loginSuccess}
                                onFailure={this.loginFailure}
                            >
                                {this.props.withContinueAsGuest && (
                                    <Button
                                        marginTop="4"
                                        content="Continue as guest"
                                        onClick={this.handleContinueAsGuest}
                                    />
                                )}
                            </LoginForm>
                        </Row>
                    </ContentSection>
                </Modal>
            </ModalPage>
        )
    }
}

const mapStateToProps = (state, pageProps) => {
    var props = Object.assign({}, act.defaultState)

    props.teamId = ""
    if (pageProps.match) {
        props.teamId = pageProps.match.params.team
    }
    props.user = state.user.value
    props.rev = new Date().getTime()
    props.isUserLoggedIn = state.isLoggedIn
    props.divisions = state.divisions.value
    props.divisionsDidLoad = state.divisions.complete

    return props
}

const mapDispatchToProps = (dispatch) => {
    return {
        login: (email, password, cb) => {
            dispatch(act.loginUser(email, password, cb))
        },
        reset: () => {
            clearToken()
            dispatch({ type: "COMMON_RESET" })
        },
        sendMagicLink: (email, link, cb) => {
            dispatch(act.sendMagicLink(email, link, cb))
        },
    }
}

export const LoginPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginPageComponent)

export const MagicLoginPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(MagicLogin)

const RequireUserComp = (props) => {
    console.log("RequireUser", props.isUserLoaded, props.isUserLoggedIn)
    var magic = window.location.href.indexOf("magic")
    if (props.isUserLoaded && props.isUserLoggedIn === false && magic < 0) {
        props.history.replace(`/${props.match.params.team_name}/session/login`)
    }
    return null
}

const mapStateToPropsRU = (state, pageProps) => {
    return {
        isUserLoaded: state.user.complete,
        isUserLoggedIn: state.isLoggedIn,
        rev: new Date().getTime(),
    }
}

const mapDispatchToPropsRU = (dispatch) => {
    return {}
}

export const RequireUser = connect(
    mapStateToPropsRU,
    mapDispatchToPropsRU
)(RequireUserComp)
